import {
  Box,
  createStyles,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  makeStyles,
  Paper,
  Theme,
  Typography,
} from '@material-ui/core';

import React from 'react';
import { Close } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      '& .MuiDialog-paperWidthSm': {
        maxWidth: '922px',
      },
    },
    closeBtn: {
      position: 'absolute',
      top: 24,
      right: 24,
      padding: 0,
    },
    popupContent: {
      padding: '0px',
    },
    popupContentArea: {
      padding: theme.spacing(1),
    },
  }),
);

interface Props {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export default ({ open, onClose, children }: Props) => {
  const classes = useStyles();

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        className={classes.modal}
        scroll="body"
        disableScrollLock
      >
        <DialogTitle>
          <Grid className={'outageTitle'} container justify="space-between">
            <Typography variant={'h1'} noWrap gutterBottom></Typography>
            <IconButton
              aria-label="close"
              color="inherit"
              onClick={onClose}
              className={classes.closeBtn}
            >
              <Close />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent className={classes.popupContent}>
          <Paper className={classes.popupContentArea}>{children}</Paper>
        </DialogContent>
      </Dialog>
    </>
  );
};
